import styled from 'styled-components';

import { colors } from 'shared/defaultTheme';

export const BackgroundDragDropWrapper = styled.div`
  border: ${({ isDrop }) =>
    isDrop ? `2px dashed ${colors.black} !important` : `1px solid ${colors.pattens}`};
  cursor: pointer;
  input[type='file'] {
    display: none;
  }
`;
